/**
 * ng-bootstrap (3.2) closes a modal on any click whose target is the modal backdrop
 * (ngb-modal-window). A press that starts inside the dialog and is released outside it - e.g.
 * selecting text by dragging past the dialog's edge - ends in such a click, and the dialog closed
 * with whatever was typed. This lets a backdrop click through only when the press also started on
 * the backdrop. Installed once, for every NgbModal in the app (AppComponent).
 */
export function installModalBackdropGuard() {
    let pressedOn: EventTarget = null;
    document.addEventListener('mousedown', event => pressedOn = event.target, true);
    document.addEventListener('click', event => {
        const target = event.target as HTMLElement;
        if (target && target.tagName === 'NGB-MODAL-WINDOW' && pressedOn !== target) {
            event.stopPropagation();   // capture phase: ng-bootstrap's own click handler never sees it
        }
        pressedOn = null;
    }, true);
}
